export var LegacyRecordType;
(function (LegacyRecordType) {
    // Privacy
    LegacyRecordType["DataPermissions"] = "DataPermissions";
    LegacyRecordType["PicturePermissions"] = "PicturePermissions";
    LegacyRecordType["GroupPicturePermissions"] = "GroupPicturePermissions";
    // Allergies & diet
    LegacyRecordType["FoodAllergies"] = "FoodAllergies";
    LegacyRecordType["MedicineAllergies"] = "MedicineAllergies";
    LegacyRecordType["HayFever"] = "HayFever";
    LegacyRecordType["OtherAllergies"] = "OtherAllergies";
    // Diet
    LegacyRecordType["Vegetarian"] = "Vegetarian";
    LegacyRecordType["Vegan"] = "Vegan";
    LegacyRecordType["Halal"] = "Halal";
    LegacyRecordType["Kosher"] = "Kosher";
    LegacyRecordType["Diet"] = "Diet";
    // Medicines
    LegacyRecordType["MedicinePermissions"] = "MedicinePermissions";
    LegacyRecordType["TetanusVaccine"] = "TetanusVaccine";
    // Health, hygiene and sleep   
    LegacyRecordType["CovidHighRisk"] = "CovidHighRisk";
    LegacyRecordType["Asthma"] = "Asthma";
    LegacyRecordType["BedWaters"] = "BedWaters";
    LegacyRecordType["Epilepsy"] = "Epilepsy";
    LegacyRecordType["HeartDisease"] = "HeartDisease";
    LegacyRecordType["SkinCondition"] = "SkinCondition";
    LegacyRecordType["Rheumatism"] = "Rheumatism";
    LegacyRecordType["SleepWalking"] = "SleepWalking";
    LegacyRecordType["Diabetes"] = "Diabetes";
    LegacyRecordType["SpecialHealthCare"] = "SpecialHealthCare";
    // Medicines
    LegacyRecordType["Medicines"] = "Medicines";
    // Sport, games, social
    LegacyRecordType["CanNotSwim"] = "CanNotSwim";
    LegacyRecordType["TiredQuickly"] = "TiredQuickly";
    LegacyRecordType["CanNotParticipateInSport"] = "CanNotParticipateInSport";
    LegacyRecordType["SpecialSocialCare"] = "SpecialSocialCare";
    // Other
    LegacyRecordType["Other"] = "Other";
    // Moved
    LegacyRecordType["FinancialProblems"] = "FinancialProblems";
})(LegacyRecordType || (LegacyRecordType = {}));
/**
 * We removed all the inverse records, because they are getting too complicated, to fast.
 * We've moved them away to seperate ones
 */
export var OldRecordType;
(function (OldRecordType) {
    // Privacy
    OldRecordType["NoData"] = "NoData";
    OldRecordType["NoPictures"] = "NoPictures";
    OldRecordType["OnlyGroupPictures"] = "OnlyGroupPictures";
    // Diet
    OldRecordType["Vegetarian"] = "Vegetarian";
    OldRecordType["Vegan"] = "Vegan";
    OldRecordType["Halal"] = "Halal";
    OldRecordType["Kosher"] = "Kosher";
    OldRecordType["Diet"] = "Diet";
    // Allergies & diet
    OldRecordType["FoodAllergies"] = "FoodAllergies";
    OldRecordType["MedicineAllergies"] = "MedicineAllergies";
    OldRecordType["OtherAllergies"] = "OtherAllergies";
    // Medicines
    OldRecordType["NoPermissionForMedicines"] = "NoPermissionForMedicines";
    // Health, hygiene and sleep
    OldRecordType["HayFever"] = "HayFever";
    OldRecordType["Asthma"] = "Asthma";
    OldRecordType["BedWaters"] = "BedWaters";
    OldRecordType["Epilepsy"] = "Epilepsy";
    OldRecordType["HeartDisease"] = "HeartDisease";
    OldRecordType["SkinCondition"] = "SkinCondition";
    OldRecordType["Rheumatism"] = "Rheumatism";
    OldRecordType["SleepWalking"] = "SleepWalking";
    OldRecordType["Diabetes"] = "Diabetes";
    OldRecordType["SpecialHealthCare"] = "SpecialHealthCare";
    OldRecordType["Medicines"] = "Medicines";
    // Sport, games, social
    OldRecordType["CanNotSwim"] = "CanNotSwim";
    OldRecordType["TiredQuickly"] = "TiredQuickly";
    OldRecordType["CanNotParticipateInSport"] = "CanNotParticipateInSport";
    OldRecordType["SpecialSocialCare"] = "SpecialSocialCare";
    OldRecordType["FinancialProblems"] = "FinancialProblems";
    // Other
    OldRecordType["Other"] = "Other";
})(OldRecordType || (OldRecordType = {}));
export var LegacyRecordTypePriority;
(function (LegacyRecordTypePriority) {
    LegacyRecordTypePriority["High"] = "High";
    LegacyRecordTypePriority["Medium"] = "Medium";
    LegacyRecordTypePriority["Low"] = "Low";
})(LegacyRecordTypePriority || (LegacyRecordTypePriority = {}));
//# sourceMappingURL=LegacyRecordType.js.map